<template>
  <div
    v-show="subBoxActive"
    class="menu-item__subbox"
    style="display: block"
  >
    <div class="wrapper">
      <div class="header-content">
        <div
          v-for="(item, index) in cpyList"
          :key="index"
          class="header-content__item"
        >
          <div class="header-content__item__left">
            <img class="h-content-icon" :src="item.src" alt="">
            <span class="h-content-title">{{ item.label }}</span>
          </div>
          <div class="header-content__item__right">
            <a
              v-for="child in item.children"
              :key="`图库-${child.lotteryCode}-${child.name}`"
              class="button-primary"
              :href="child.natureLink"
              @click.prevent="handleGoto(child)"
            >
              <span class="button-primary__text">{{
                child.name
              }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NewspaperMenuSubbox',
  props: {
    subBoxActive: {
      type: Boolean,
      required: true
    },
    cpyList: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleGoto(link) {
      window.location.href = link.natureLink
    }
  }
}
</script>
<style lang="scss" scoped>
.header-content {
  &__item__left {
    justify-content: flex-start;
    align-items: center;
    padding: 20PX;
  }
  &__item__right {
    align-items: center;
    row-gap: 6PX;
  }
}
</style>
